import cn from "classnames";

const talentColors = {
  fire: {
    bg: "bg-radial from-pk-red-4 via-pk-fire to-pk-fire",
  },
  water: {
    bg: "bg-radial from-pk-water to-pk-blue-5",
  },
  grass: {
    bg: "bg-radial from-pk-grass to-pk-green-4",
  },
  electric: {
    bg: "bg-radial from-pk-electric to-pk-yellow-3",
  },
  ice: {
    bg: "bg-radial from-pk-ice to-pk-blue-4",
  },
  fighting: {
    bg: "bg-radial from-pk-fighting to-pk-red-4",
  },
  poison: {
    bg: "bg-radial from-pk-poison to-pk-purple-4",
  },
  ground: {
    bg: "bg-radial from-pk-ground to-pk-orange-2",
  },
  flying: {
    bg: "bg-radial from-pk-flying to-pk-blue-5",
  },
  psychic: {
    bg: "bg-radial from-pk-psychic to-pk-garnet-4",
  },
  bug: {
    bg: "bg-radial from-pk-bug to-pk-green-5",
  },
  rock: {
    bg: "bg-radial from-pk-rock to-pk-gray-4",
  },
  dragon: {
    bg: "bg-radial from-pk-dragon to-pk-purple-4",
  },
  steel: {
    bg: "bg-radial from-pk-steel to-pk-blue-4",
  },
  fairy: {
    bg: "bg-radial from-pk-fairy to-pk-garnet-4",
  },
  dark: {
    bg: "bg-radial from-pk-dark to-pk-gray-2",
  },
  ghost: {
    bg: "bg-radial from-pk-ghost to-pk-pink-4",
  },
  normal: {
    bg: "bg-radial from-pk-normal to-pk-gray-5",
  },
};

export const PokemonTalent = ({
  talent,
  width = 28,
  height = 28,
  className,
}: {
  talent: string;
  width?: number;
  height?: number;
  className?: string;
}) => {
  const talentColor =
    talentColors[talent.toLowerCase() as keyof typeof talentColors];

  return (
    <div
      className={cn(
        "relative flex items-center justify-center rounded-lg",
        "border-2 border-white/40", // Light stroke for DS vibe
        "border-b-4 border-b-black/20", // Darker bottom edge for 3D effect
        "shadow-[inset_0_1px_0_rgba(255,255,255,0.4)]", // Top highlight
        "p-0.5",
        talentColor?.bg || "bg-pk-gray-2",
        className,
      )}
      title={talent}
    >
      {/* Glass Shine */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none rounded-lg" />

      <img
        src={`/assets/pokemon-types/${talent.toLocaleLowerCase()}.svg`}
        alt={talent}
        className="drop-shadow-sm relative z-10"
        style={{
          width,
          height,
        }}
      />
    </div>
  );
};
